var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7666 25.9944V21.8223",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8091 7.33486C29.4603 7.33507 30.1051 7.46549 30.7065 7.71866C31.3079 7.97184 31.8541 8.34279 32.3137 8.81025C32.7734 9.27771 33.1376 9.83248 33.3854 10.4428C33.6333 11.0532 33.7597 11.7071 33.7578 12.3671V18.0242C29.1409 20.5185 23.9895 21.8231 18.7578 21.8231C13.5261 21.8231 8.37468 20.5185 3.75781 18.0242V12.3507C3.75802 11.6906 3.88672 11.0372 4.1365 10.4276C4.38628 9.81813 4.75215 9.26454 5.21335 8.79861C5.67455 8.33268 6.22199 7.96354 6.82416 7.71237C7.42633 7.46119 8.07159 7.33291 8.72275 7.33486H28.8091Z",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4447 7.32809V6.7262C24.4442 5.76243 24.0663 4.83825 23.394 4.15676C22.7216 3.47527 21.8099 3.09223 20.859 3.0918H16.6728C15.722 3.09223 14.8103 3.47527 14.1379 4.15676C13.4655 4.83825 13.0876 5.76243 13.0872 6.7262V7.32809",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79004 24.0321L4.09822 28.1582C4.19965 29.5007 4.79767 30.7549 5.77241 31.6697C6.74715 32.5845 8.02668 33.0924 9.3551 33.0918H28.16C29.4884 33.0924 30.7679 32.5845 31.7427 31.6697C32.7174 30.7549 33.3154 29.5007 33.4169 28.1582L33.7251 24.0321",
    stroke: "#273239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience-icon.37daef7e3a9fc4443c1720728ad3d341.svg";
export { ForwardRef as ReactComponent };